import { render } from "./AuthAdminComponent.vue?vue&type=template&id=48e5299c&ts=true"
import script from "./AuthAdminComponent.vue?vue&type=script&lang=ts"
export * from "./AuthAdminComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__